import screenfull from 'screenfull';
export default {
  name: 'ScreenfullButton',
  data: function data() {
    return {
      isFullscreen: false
    };
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  methods: {
    click: function click() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: 'your browser doesn\'t support this',
          type: 'warning'
        });
        return false;
      }
      screenfull.toggle();
    },
    change: function change() {
      this.isFullscreen = screenfull.isFullscreen;
    },
    init: function init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change);
      }
    },
    destroy: function destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change);
      }
    }
  }
};